import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

const Transparency = () => {
  return (
    <section
      data-testid="transparency-section"
      className="relative py-20 lg:py-28"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="relative overflow-hidden rounded-3xl border border-white/[0.08] bg-gradient-to-b from-[#0e0e10] to-[#0a0a0c] p-10 lg:p-16"
        >
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.22),transparent_60%)] blur-2xl" />
          <div className="pointer-events-none absolute -right-24 -bottom-24 h-72 w-72 rounded-full bg-[radial-gradient(circle,rgba(180,140,40,0.14),transparent_60%)] blur-2xl" />

          <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <div className="mb-4 flex items-center gap-3">
                <div className="grid h-9 w-9 place-items-center rounded-lg border border-[var(--gold)]/30 bg-[var(--gold)]/10 text-[var(--gold-bright)]">
                  <ShieldCheck className="h-4 w-4" />
                </div>
                <span className="font-mono-label text-[var(--gold)]">
                  Our Promise
                </span>
              </div>
              <h2 className="font-display text-4xl leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[52px]">
                No hype.<br />
                <span className="font-serif-display italic gold-gradient-text">
                  Just honest growth.
                </span>
              </h2>
              <p className="mt-6 max-w-xl text-[15.5px] leading-relaxed text-zinc-400">
                We&apos;re building this company the right way. Real projects.
                Real relationships. Real progress. Every launch teaches us
                something. Every client becomes part of our story.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 lg:col-span-5">
              {[
                { k: "Stage", v: "Early Growth" },
                { k: "Approach", v: "Client-First" },
                { k: "Playbook", v: "Ship Fast" },
                { k: "Mindset", v: "Long-Term" },
              ].map((c) => (
                <div
                  key={c.k}
                  className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5"
                >
                  <div className="font-mono-label text-zinc-500">{c.k}</div>
                  <div className="mt-2 font-display text-xl font-semibold text-white">
                    {c.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Transparency;
